import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  // connect() {
  //   console.log("Conectando payment controller");
  // }
  hola122() {
    // console.log("coneection stimulu");
  }
}
